import { useAuth } from "hooks/authHook"

export const CanView = ({ children, access = [] }) => {
  const { isLoading, isAuthenticated, hasAnyPermission } = useAuth()

  // Show nothing while loading
  if (isLoading) return null

  // Show children only if authenticated and has required permissions
  if (!isAuthenticated) return null

  if (access.length && !hasAnyPermission(access))
    return null

  return <>{children}</>
}
